import React from 'react'

export const formatCurrency = n =>
    n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')

const Currency = ({ value }) => (
    <span className="currency">$ {formatCurrency(value || 0)}</span>
)

export default Currency
